(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  const card = e.target.closest('#shopify-section-{{ section.id }} .cc-card');
  if(!card) return;
  const link = card.querySelector('.cc-value--link') || card.querySelector('.cc-btn');
  if(link && e.target !== link && !e.target.closest('a')) link.click();
});

(function(){
  const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
  function copy(t){ try{ navigator.clipboard.writeText(t);}catch(e){} }
  function toast(msg){
    const t=document.createElement('div'); t.textContent=msg;
    Object.assign(t.style,{position:'fixed',left:'50%',bottom:'24px',transform:'translateX(-50%)',padding:'10px 14px',background:'#111',color:'#fff',borderRadius:'6px',fontSize:'14px',zIndex:99999,opacity:'0.94'}); 
    document.body.appendChild(t); setTimeout(()=>t.remove(),2000);
  }
  document.addEventListener('click', function(e){
    const a = e.target.closest('#shopify-section-{{ section.id }} .cc-value--link');
    if(!a) return;
    const href = a.getAttribute('href') || '';
    if(isMobile) return;
    if(href.startsWith('mailto:')){
      setTimeout(function(){
        const email = href.replace('mailto:','');
        window.open('https://mail.google.com/mail/?view=cm&to='+encodeURIComponent(email),'_blank','noopener');
      },600);
    }
    if(href.startsWith('tel:')){
      const num = href.replace('tel:','');
      setTimeout(function(){ copy(num); toast('Number copied: '+num); },600);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
